<template>
  <nav class="list-nav">
    <div class="tabs">
      <ul v-if="tabItems && tabItems.length > 0">
        <li :class="{ 'is-active': activeItem === 'My Jobs' }">
          <a href="#" @click.prevent="onNavItemClick('My Jobs')">
            My Jobs
          </a>
        </li>
        <li :class="{ 'is-active': activeItem === 'My Board' }">
          <a href="#" @click.prevent="onNavItemClick('My Board')">
            My Board
          </a>
        </li>

      </ul>
    </div>
    <div class="field is-grouped" v-if="showSearch">
      <div class="control">
        <input type="text"
               class="input"
               placeholder="Keyword"
               v-model="keywordValue"
               @keydown.prevent.enter="$emit('enter')" />
      </div>
      <div class="control" v-if="selectItems && selectItems.length > 0">
        <div class="select">
          <select v-model="selectedItemComp">
            <option v-for="item in selectItems" :key="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'AdminJobListNav',
  props: {
    active: {
      type: String,
      default: 'all'
    },
    tabItems: {
      type: Array,
      default: () => []
    },
    selectItems: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: String
    },
    keyword: {
      type: String,
      default: ''
    },
    suffixes: {
      type: Array,
      default: null
    },
    showSearch: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    ...mapState('widget', [
      'jobs',
      'companies',
      'talents'
    ]),
    ...mapState('adminCompanies', [
      'companies',
      'requestedCompanies',
      'activeCompanies'
    ]),
    getRequestedCompanies () {
      return this.requestedCompanies.length
    },
    getActiveCompanies () {
      return this.activeCompanies.length
    },
    keywordValue: {
      get () { return this.keyword },
      set (value) {
        this.$emit('update:keyword', value)
      }
    },
    selectedItemComp: {
      get () { return this.selectedItemModel || this.selectedItem },
      set (value) {
        this.$emit('select', value)
        this.selectedItemModel = value
      }
    },
    activeItem: {
      get () { return this.activeModel || this.active },
      set (value) {
        this.$emit('active', value)
        this.$emit('update:active', value)
        this.activeModel = value
      }
    }
  },
  data () {
    return {
      filter: null,
      selectedItemModel: null,
      activeModel: null
    }
  },
  methods: {
    getBadgeClass (item) {
      return this.activeItem !== item ? 'badge' : 'badge bold'
    },
    onNavItemClick (item) {
      this.activeItem = item
    },
    getCategory (value) {
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.list-nav {
  height: 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 40px;

  > .field .control {
    margin-top: 0;
  }

  .badge{
    background: #6AC5EC;
    padding-left: 8px;
    padding-right: 8px;
    margin-right: 10px;
    //width:24px;
    border-radius: 8px;
    color: white;
  }
  .bold{
    font-weight: bolder;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/jobs/admin-job-list-nav.vue